<template>
  <b-container>
    <b-row>
      <b-col
        class="d-flex flex-column justify-content-center login-wrapper--right-form"
      >
        <div class="mb-2">
          <b-link to="/">
            <img
              src="~@/assets/img/back.png"
              alt="back"
              class="cursor mt-md-5 mb-md-5"
            />
          </b-link>
        </div>
        <div class="mt-5">
          <h2 class="font-weight-bold">Welcome Back</h2>
          <p class="mt-3"></p>
        </div>

        <b-form class="mt-3" @submit.prevent="onSubmit">
          <b-row no-gutters>
            <b-col cols="12">
              <b-form-group id="input-group-1" class="col-12">
                <label>Start with your email</label>
                <span class="focus-border"></span>
                <b-form-input
                  ref="emailField"
                  id="input-1"
                  v-model="form.email"
                  :class="form.email ? 'has-content' : ''"
                  type="email"
                  required
                  autofocus
                  placeholder="your@email.com"
                  :value="form.email"
                ></b-form-input>
              </b-form-group>

              <b-form-group id="input-group-2" class="col-12">
                <label class="d-block">
                  Password time
                  <b-link
                    class="form-link float-right mb-n2"
                    to="/forgot-password"
                  >
                    <small><small>Forgot password?</small></small>
                  </b-link>
                </label>
                <span class="focus-border"></span>
                <b-form-input
                  ref="pwField"
                  id="input-2"
                  v-model="form.password"
                  :class="form.password ? 'has-content' : ''"
                  type="password"
                  autocomplete="new-password"
                  required
                  placeholder="yourpassword"
                  :value="form.password"
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" block>
              <b-button
                :disabled="form.$busy"
                class="radius-30 py-3 pl-4 pr-0"
                type="submit"
                variant="primary"
                block
              >
                LOGIN
                <b-spinner
                  small
                  class="float-right mt-1 mr-3"
                  :class="form.$busy ? `visible` : `invisible`"
                />
              </b-button>

              <!-- API Error Message -->
              <div
                class="mt-4 text-warning"
                v-if="form.$errorMessage"
                v-text="'Uh oh, ' + form.$errorMessage.toLowerCase() + ' 😢'"
              />

              <div class="form-link-cont text-right mt-4">
                <b-link class="form-link" to="/register">
                  <small>Don't have an account?</small>
                </b-link>
              </div>
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Form from '@/utils/form'

export default {
  components: {},
  data() {
    return {
      form: new Form({
        email: '',
        password: '',
      }),
    }
  },

  methods: {
    async onSubmit(evt) {
      this.form.$busy = true
      await this.$api
        .post('auth/login', this.form.$data())
        .then(({ data }) => {
          this.form.$busy = false
          this.$store.commit('auth/setToken', data.data.token)
          this.$store.commit('auth/setUser', data.data.user)
          this.$router.replace({ name: 'influencer' })
        })
        .catch((error) => {
          this.form.$handleError(error)
        })
    },
  },

  watch: {
    'form.email'() {
      this.form.$clearError('email')
    },
    'form.password'() {
      this.form.$clearError('password')
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  height: 100%;
}
</style>
